import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "reviewer-setup",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "admin-portfolio-manager" */ "./components"),
      import(
        /* webpackChunkName: "admin-portfolio-manager" */ "./modules/ReviewerSetupModule"
      ),
    ])
      .then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "reviewerSetup",
          reducer,
        });
        return component;
      })
      .catch(err => {
        return err;
      })
  ),
});
